// extracted by mini-css-extract-plugin
module.exports = {"linkedInIcon":"_1sVIG"};